import { TransportLocationService } from 'src/app/angularJS/services/transport-location/transport-location.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

export class TransportLocationsPublisherController {
  public static $inject = [
    'transportLocationService',
    'UserMessages',
    'breadcrumbService',
    '$stateParams',
    '$q',
    '$rootScope'
  ];
  public transportLocations: Array<InterACT.Interfaces.TransportLocations.TransportLocation> = [];
  public aPageOfTransportLocations: Array<InterACT.Interfaces.TransportLocations.TransportLocation> = [];
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    totalCount: 0,
    perPageCount: 15,
    currentPage: 1
  };
  constructor(
    private transportLocationService: TransportLocationService,
    private userMessages: UserMessagesService,
    private breadcrumbService: BreadcrumbService,
    private $stateParams: ng.ui.IStateParamsService,
    private $q: ng.IQService,
    private $rootScope: InterACT.Interfaces.IActoraRootScope
  ) {
    this.activate();
  }

  /**
 * A method that returns the reference data for the supplied transport location
 * @param transportLocation the location to get the reference data for
 */
  public getLocationReferenceData(transportLocation: InterACT.Interfaces.TransportLocations.TransportLocation) {
    const locationReferenceData = {
      name: undefined,
      value: undefined
    };

    if (!transportLocation.references) {
      return locationReferenceData;
    }

    for (const referenceTypeName in transportLocation.references) {
      locationReferenceData.name = referenceTypeName;
      locationReferenceData.value = transportLocation.references[referenceTypeName];
      return locationReferenceData;
    }
  }

  /**
   * A method that gets a page worth of transport locations
   * @param pageNumber the page number to retrieve
   * @param perPage the number of locations to retrieve per page
   */
  public getAPageOfTransportLocations = (pageNumber: number, perPage: number) => {
    if (!this.transportLocations) {
      return;
    }

    if (!perPage) {
      perPage = 15;
    }

    this.paginatorData.totalCount = this.transportLocations.length;
    this.paginatorData.currentPage = pageNumber;

    const startIndex = (pageNumber - 1) * perPage;
    const endIndex = startIndex + (perPage - 1);
    this.aPageOfTransportLocations = [];

    for (let c = startIndex; c <= endIndex; c++) {
      if (!this.transportLocations[c]) {
        break;
      }

      this.aPageOfTransportLocations.push(this.transportLocations[c]);
    }
  };

  /**
   * A method that determines whether the page has the ability to publish locations or not
   */
  public canPublish = () => {
    return this.transportLocations && this.transportLocations.some((location) => {
      return (location.status === <any>'NOT_UPLOADED' || location.status === <any>'UPLOAD_FAILED');
    });
  };

  /**
 * A method that deletes the supplied transport location from the list of lcoations to be uplaoded
 */
  public deleteTransportLocation = (transportLocation: InterACT.Interfaces.TransportLocations.TransportLocation) => {
    this.transportLocations.splice(this.transportLocations.indexOf(transportLocation), 1);
    this.aPageOfTransportLocations.splice(this.aPageOfTransportLocations.indexOf(transportLocation), 1);
    this.paginatorData.totalCount -= 1;
  }

  /**
   * A method that publishes the transport locations on the controller to the services
   */
  public publish = () => {
    const allPromises = [];
    this.$rootScope.showSpinner = true;

    for (let c = 0; c < this.transportLocations.length; c++) {
      const transportLocationCopy = JSON.parse(JSON.stringify(this.transportLocations[c]));
      delete transportLocationCopy['$$hashKey'];
      delete transportLocationCopy['failureMessage'];

      if (transportLocationCopy.status !== 'COMPLETE') {
        allPromises.push(this.uploadTransportLocation(transportLocationCopy, this.transportLocations[c]));
      }
    }

    this.$q.all(allPromises).then(() => {
      this.$rootScope.showSpinner = false;
      this.userMessages.showToast('LOCATIONS_SUCCESSFULLY_UPLOADED');
    }).catch(() => {
      this.$rootScope.showSpinner = false;
    });
  }

  /**
   * A method that uploads a single transport location
   * @param transportLocationCopy a copy of the transport location to be uploaded. Cannot upload original as it has properties added by angular
   * @param originalTransportLocation the original transport location that is bound by angular
   */
  private uploadTransportLocation(transportLocationCopy: InterACT.Interfaces.TransportLocations.TransportLocation, originalTransportLocation: InterACT.Interfaces.TransportLocations.TransportLocation) {
    transportLocationCopy.status = 'ACTIVE';

    return this.transportLocationService.create(transportLocationCopy).then(() => {
      (<any>originalTransportLocation).status = 'COMPLETE';
      (<any>originalTransportLocation).failureMessage = '';
    }).catch((error) => {
      (<any>originalTransportLocation).status = 'UPLOAD_FAILED';
      (<any>originalTransportLocation).failureMessage = error.data.developerMessage;
    });
  }

  /**
   * A method that is called during controller instantiation
   */
  private activate() {
    this.transportLocations = this.$stateParams.transportLocations;
    this.getAPageOfTransportLocations(1, 15);

    this.breadcrumbService.setBreadcrumbs([{
      name: 'TRANSPORT_LOCATIONS',
      sref: 'transport-locations-upload'
    }, {
      name: 'UPLOAD',
      sref: 'transport-locations-publisher'
    }]);
  }
}